export default __webpack_public_path__ + "static/breadcrumbs-icons-dont-dark-af1d31a5633e0305ff706a01b8b5e33f.png";